import { graphql } from "gatsby";
import PrivacyPolicyPage from "../../../../src/pages/privacy-policy";
import * as React from 'react';
export default {
  graphql,
  PrivacyPolicyPage,
  React
};